// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/style.css
// module id = 2016
// module chunks = 0